import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { prop, theme } from 'styled-tools'

import CheckBox from '../../components/customer-form/checkbox'
import Textarea from '../../components/customer-form/textarea'
import Loader from '../../components/loader/Loader'

import { navigateToStep } from '../utils'
import { trackCancelAppointment } from '../../../utils/tracker'
import { user } from '../../../utils/initValues'
import { cancelAppointment } from '../../../utils/badaAppointmentApi'

export const Heading = styled.h1`
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-family: ${theme('cancel.step2.heading.fontFamily')};
  text-align: center;
  margin: ${theme('cancel.step2.heading.margin')};
  max-width: 550px;
  font-size: ${theme('cancel.step2.heading.fontSize.mobile')};
  line-height: ${theme('cancel.step2.heading.lineHeight.mobile')};
  font-weight: ${theme('cancel.step2.heading.fontWeight')};
  ${(props) => props.theme.media.min.sm`
    font-size: ${theme('cancel.step2.heading.fontSize.desktop')};
    line-height: ${theme('cancel.step2.heading.lineHeight.desktop')};
  `}
`

export const SubHeading = styled.h2`
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-family: ${theme('cancel.step2.subHeading.fontFamily')};
  font-size: ${theme('cancel.step2.subHeading.fontSize')};
  font-weight: ${theme('cancel.step2.subHeading.fontWeight')};
  margin-top: 10px;
  margin-bottom: 26px;
`

export const Box = styled.div`
  width: 100%;
  max-width: 550px;
  margin: 0px auto;
  background-color: ${theme('cancel.step2.box.backgroundColor')};
  padding: 20px 35px 25px 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  ul {
    padding-left: 17px;
    li {
      margin-bottom: 15px;
    }
  }
`

export const Details = styled.div`
  ${(props) => props.cancellationReason === 'OtherReason' && 'width: 100%;'}
`

export const Link = styled.button.attrs({ type: 'button' })`
  font-family: ${theme('typography.paragraph.fontFamily')};
  background-color: ${theme('cancel.step2.link.backgroundColor')};
  color: #ffffff;
  text-decoration: none;
  padding: ${(props) =>
    theme('cancel.step2.link.padding')(props) || '13px 30px 13px 30px'};
  font-size: 16px;
  border-radius: ${theme('cancel.step2.link.borderRadius')};
  width: 100%;
  font-weight: ${(props) =>
    theme('cancel.step2.link.fontWeight')(props) || 500};
  text-transform: ${(props) =>
    theme('cancel.step2.link.textTransform')(props) || 'none'};
  display: block;
  cursor: pointer;
  border: none;
  :hover:not(:disabled) {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const LoaderCover = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
`

export const LoaderContainer = styled.div`
  margin-top: 40vh;
`

export const ConfirmContainer = styled.div`
  text-align: center;
  margin: 30px auto;
  max-width: 550px;
`

export const RadioGroupContainer = styled.div`
  display: block;
  position: relative;
  width: 100%;
  span {
    label {
      display: block;
      font-weight: 300;
      font-size: 16px;
      margin-bottom: 15px;
      span {
        font-family: ${theme('typography.paragraph.fontFamily')};
        color: ${(props) => theme('cancel.step2.radioButton.color')(props)};
      }
    }
  }
`

export const Tooltip = styled.div`
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-size: 13px;
  padding: 10px 15px 10px 15px;
  position: absolute;
  background-color: #fff;
  width: 270px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  top: ${theme('cancel.step2.tooltip.top.mobile')};
  left: ${theme('cancel.step2.tooltip.left.mobile')};
  ${(props) => props.theme.media.min.sm`
    top: ${theme('cancel.step2.tooltip.top.desktop')};
    left: ${theme('cancel.step2.tooltip.left.desktop')};
  `}
`

export const TooltipHeading = styled.h4`
  font-size: 13px;
  font-weight: 700;
  margin: 0px;
`

export const TooltipText = styled.div`
  font-family: ${theme('typography.paragraph.fontFamily')};
  span {
    text-decoration: underline;
    cursor: pointer;
  }
`

export const CaretContainer = styled.div`
  position: relative;
`

export const Caret = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  display: inline-block;
  border: 10px solid transparent;
  border-right-color: #ffffff;
  top: -84px;
  left: -4px;
  transform: rotate(90deg);
  ${(props) => props.theme.media.min.sm`
    top: -49px;
    left: -34px;
    transform: none;
  `}
`

export const BackLink = styled.a`
  font-family: ${theme('typography.paragraph.fontFamily')};
  color: ${theme('cancel.step2.backLink.color')};
  font-size: ${theme('cancel.step2.backLink.fontSize')};
  text-align: center;
  display: block;
  margin-top: 30px;
`

export const SubStepBackButton = styled.button`
  font-family: ${theme('typography.paragraph.fontFamily')};
  color: ${theme('cancel.step2.backLink.color')};
  font-size: ${theme('cancel.step2.backLink.fontSize')};
  text-align: center;
  display: block;
  margin: 20px auto 0;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`

export const StyledCheckBox = styled(CheckBox)`
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
`

export const OptionsContainer = styled.div`
  margin-left: 25px;
  margin-bottom: 15px;
`

export const StyledTextarea = styled(Textarea)`
  ${(props) => !props.isFullWidth && 'margin-left: 29px;'}
  ${(props) => !props.isFullWidth && 'width: calc(100% - 29px);'}
  ${(props) => props.isFullWidth && 'width: 100%;'}
  textarea& {
    border: 1px solid ${theme('forms.colors.border')};

    &:focus,
    &:active {
      outline: none;
      border: 1px solid ${prop('theme.forms.colors.activeBorder')};
      box-shadow: ${theme('colors.accentShadow')};
    }
    &::placeholder {
      color: ${theme('forms.colors.placeholder')};
    }
  }

  font-family: ${theme('typography.paragraph.fontFamily')};
  font-size: '16px';

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 60px
      ${prop('theme.forms.colors.prefilledBackground')} inset !important;
  }
`

export const getFirstName = (fullName) => {
  if (fullName.indexOf(' ') > -1) {
    return fullName.split(' ')[0]
  }
  return fullName
}

export const buildDeactivationPayload = ({
  deactivateCustomer = false,
  deactivationReason = '',
  deactivationTimeframe = '',
} = {}) => ({
  deactivateCustomer,
  deactivationReason: deactivateCustomer ? deactivationReason || undefined : undefined,
  deactivationTimeframe: deactivateCustomer
    ? deactivationTimeframe || undefined
    : undefined,
})

export const useCancelStep2Submit = ({ appointment, isStore }) => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const cancelledBy = user?.email || (isStore ? 'store' : 'customer')
  const cancelledByName = user?.name || ''

  const runCancel = (reason, deactivation) => {
    setLoading(true)
    const deactivationPayload = deactivation
      ? buildDeactivationPayload(deactivation)
      : undefined
    cancelAppointment(
      appointment.id,
      cancelledBy,
      cancelledByName,
      reason,
      deactivationPayload?.deactivateCustomer || undefined,
      deactivationPayload?.deactivateCustomer
        ? deactivationPayload.deactivationReason
        : undefined,
      deactivationPayload?.deactivateCustomer
        ? deactivationPayload.deactivationTimeframe
        : undefined
    ).then(() => {
      const isDesigner = window.location.search.includes('store=true')
      trackCancelAppointment(appointment.id, isDesigner)
      const { parent } = window
      if (parent) {
        parent.postMessage(
          {
            type: 'appointment-canceled',
            appointmentId: appointment.id,
            deactivateCustomer:
              deactivationPayload && deactivationPayload.deactivateCustomer,
            deactivationReason: deactivationPayload?.deactivationReason,
            deactivationTimeframe: deactivationPayload?.deactivationTimeframe,
          },
          '*'
        )
      }
      navigateToStep(3, history, isStore)
    })
  }

  return { runCancel, loading }
}

export const CancelStep2LoadingOverlay = ({ loading }) =>
  loading ? (
    <LoaderCover>
      <LoaderContainer>
        <Loader duration={1} />
      </LoaderContainer>
    </LoaderCover>
  ) : null
